import { render, staticRenderFns } from "./reportProficientCarFee.vue?vue&type=template&id=316cd12a&scoped=true"
import script from "./reportProficientCarFee.vue?vue&type=script&lang=js"
export * from "./reportProficientCarFee.vue?vue&type=script&lang=js"
import style0 from "./reportProficientCarFee.vue?vue&type=style&index=0&id=316cd12a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316cd12a",
  null
  
)

export default component.exports